import React, {useState,useEffect} from 'react';
import MenuSupport from "./MenuSupport";
import SupportWork from "./SupportWork";
import { Menu,Table, Button, Space, Spin } from 'antd';
import { AppstoreOutlined, MailOutlined, SettingOutlined } from '@ant-design/icons';
import axios from "axios";
import moment from 'moment-timezone';



/**
 * Функциональный компонент, который отображает новые сообщение с поддержку которые не были приняты
 */
export default function SupportNew(props) {

    /**
     * Получение imba_id, объявление столбцов таблицы, объявление массива списка диалогов и его состояния.
     */
    
    const imba_id = props.match.params.imba_id;
    //let loading = true;
    const [loading, setLoading] = useState(false);
    const tz= moment.tz.guess();
    moment.tz.setDefault(tz);


    const columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.id - b.id,
            key: 'id',
        },
        {
            title: `TIME ${tz}`,
            dataIndex: 'time',
            defaultSortOrder: 'descend',
            //sorter: (a, b) => new Date(a.time) - new Date(b.time),
            sorter: (a, b) => new Date(a.time_old) - new Date(b.time_old),
            key: 'time',
        },

        {
            title: 'Message',
            dataIndex: 'message',
            key: 'message',
        },
        {
            title: 'RECEIVER',
            dataIndex: 'Receiver',
            key: 'Receiver',
        },
        {
            title: 'USER_ID',
            dataIndex: 'User_id',
            defaultSortOrder: 'descend',
            sorter: (a, b) => a.User_id - b.User_id,
            key: 'User_id',
        },

        {
            title: 'ACTIONS',
            dataIndex: 'Actions',
            key: 'Actions',
        },

    ];

    const colSourceBlank = [
        {
            title: 'Loading...',
            dataIndex: 'loading',
            key: 'loading',
        }
    ];

    const dataSourceBlank = [];
    const [dataSourceDialogs, setDataSourceDialogs] = useState(dataSourceBlank);
    const [columnSourceDialogs, setColumnSourceDialogs] = useState(colSourceBlank);

    /**
     * Функция Которая делает api запрос на сервер и возвращает список диалогов
     */
    async function getNewDialogs(imba_id) {
        let url = `https://api.imbachat.com/imbasupport/v2/`+imba_id+`/new-dialogss`;
        axios.post(url, {
            'jwt': localStorage.getItem('comet-token'),
            'imba_id': imba_id,
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            }
        }).then(dialogs => {
            if(dialogs.data['dialogs']){

                dialogs = dialogs.data['dialogs']['lines'];
                
                var tempArrayDialogs = [];
                for (let key in dialogs) {
                    
                    var offset =  moment(dialogs[key]['created_at']).utcOffset()/60
                    var time_new = 0;
                    if(offset>0){
                         time_new = moment.utc(dialogs[key]['created_at']).add(offset,'hours').format("DD-MM-YYYY hh:mm:ss A");
                    }
                    else{
                        time_new = moment.utc(dialogs[key]['created_at']).subtract((-1*offset),'hours').format("DD-MM-YYYY hh:mm:ss A");
                    }
                    
                    
                    tempArrayDialogs.push(
                        {
                            id: dialogs[key]['id'],
                            time: time_new,
                            time_old: dialogs[key]['created_at'],
                            message: dialogs[key]['last_message']['message'],
                            Receiver:dialogs[key]['name'] ,
                            User_id: dialogs[key]['admin_id'],
                            Actions:  <div className={'control_'+key}><Button type="primary" onClick={() =>acceptDialog(dialogs[key]['id'])}>Accept</Button><a href={"/#/"+imba_id+"/room/"+dialogs[key]['id']}><Button type="dashed" >Admin</Button></a><Button type="dashed" onClick={() =>completedDialog(dialogs[key]['id'])}>Completed</Button></div>,
                            key: key,
                        }
                    );
                }
                setColumnSourceDialogs(columns);
                setDataSourceDialogs(tempArrayDialogs);
            }
            
        });

    }


    /**
     * хук обновления состояния списка диалогов
     */
    
    useEffect( () => {
        const interval = setInterval(()=>{
            getNewDialogs(imba_id);
        },10000);
        return () => {
            clearInterval(interval)
          };
    }, []);




    /**
     * Функция получения диалога при нажтии на кнопку ADMIN в сообщении
     */

    async function getDialog(id_dialog) {
        let url = `https://api.imbachat.com/imbasupport/v2/`+imba_id+`/show-messages`;
        axios.post(url, {
            'jwt': localStorage.getItem('comet-token'),
            'imba_id': imba_id,
            'dialog_id': id_dialog,
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
               // "Access-Control-Allow-Headers": "*",
            }
        })
        // тут добавить отображение диалога (надо придумать верстку)
    }

    /**
     * Функция приняти дилога в поддержку
     */

    async function acceptDialog(id_dialog) {
        setLoading(true);
        let url = `https://api.imbachat.com/imbasupport/v2/`+imba_id+`/assign-user`;
        axios.post(url, {
            'jwt': localStorage.getItem('comet-token'),
            'imba_id': imba_id,
            'dialog_id': id_dialog,
            'user_id': localStorage.getItem('user_id')
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            }
        }).then((data) => {
            setLoading(false);
            if(data.data.success==false){
                window.imbaChat.showNotification('Внимание', 'Диалог уже был принят ранее')
            }
            else{
                window.imbaChat.updateContactList().then(()=>{ 
                    
                    getNewDialogs(imba_id)
                    /*if(data.data.room_id) window.imbaChat.openRoom(data.data.room_id).then(()=>{
                    }).catch(() => {
                      })*/
                      openDialog(id_dialog)
                });
            }
            
        })



    }
    async function openDialog(room_id)
    {
        //let url = `https://dashboard-habby.imbachat.com/imbasupport/v2/`+'8755'+`/check-room`;
        let url = `https://api.imbachat.com/imbachat/v1/`+'8755'+`/check-room`;
        let exit = false;
        window.imbaApi.openChat();
        await axios.post(url, {
            'jwt': localStorage.getItem('comet-token'),
            'imba_id': imba_id,
            'room_id': room_id
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            }
        }).then(data => {
            if(data.data.success){
                exit = true;
            }
            
            
        });
        if(exit) {
            completedDialog(room_id)
            window.imbaChat.showNotification('Внимание', 'Диалог был завершен пользователем. Для его закрытия нажмите completed')
            return;
        }
        window.imbaChat.openRoom(room_id);
    }

    /**
     * Функция удаления обращения до принятия в поддержку
     */

     async function completedDialog(id_dialog) {

        let url = `https://api.imbachat.com/imbasupport/v2/`+imba_id+`/solved`;
        axios.post(url, {
            'jwt': localStorage.getItem('comet-token'),
            'imba_id': imba_id,
            'dialog_id': id_dialog,
        },{
            headers: {
                //"Access-Control-Allow-Origin": "*",
                //"Access-Control-Allow-Methods": "POST, GET, PUT, DELETE, OPTIONS",
                //"Access-Control-Allow-Headers": "*",
            }
        }).then(() => {
            getNewDialogs(imba_id);
        })
    }

    return(
        <div className={'tablename'}>
            <MenuSupport />
            <Space size="middle" className={'absolute'}>
                <Spin size="large" spinning={loading} className={'absolute'} />
            </Space>
            <Table columns={columnSourceDialogs} dataSource={dataSourceDialogs}  pagination={{ defaultPageSize: 20}}/>
        </div>
    )


}

